import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f3be090"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "flex bg-red-500 banner"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex-shrink-0 w-4 bg-black opacity-25" }, null, -1));
const _hoisted_3 = { class: "flex items-center justify-between flex-1 min-w-0 gap-4 pl-6 pr-10 py-9" };
const _hoisted_4 = { class: "text-sm text-white truncate min-w-24" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = { class: "min-w-36" };
const _hoisted_7 = { key: 1 };
import componentI18n from '@/i18n/componentI18n';
const __default__ = { ...componentI18n('components.workspaces.payment_banner') };
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { redirectToPaymentMethod } from '@/data/workspaces';
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'PaymentBanner',
    setup(__props) {
        const store = useStore();
        const isCtaLoading = ref(false);
        const workspace = computed(() => store.getters.workspace);
        const isOwner = computed(() => store.getters.isWorkspaceOwner);
        const paymentStatus = computed(() => workspace.value?.paymentStatus);
        function onManagePayment() {
            isCtaLoading.value = true;
            redirectToPaymentMethod(workspace.value.id);
        }
        return (_ctx, _cache) => {
            return (_unref(paymentStatus) === 'failed')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('failed_message')), 1),
                        (_unref(isOwner))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: _normalizeClass(["h-8 text-sm font-bold text-white rounded-full px-7", {
                                        'border border-white hover:bg-white hover:bg-opacity-10': !isCtaLoading.value,
                                        'bg-white bg-opacity-10': isCtaLoading.value
                                    }]),
                                disabled: isCtaLoading.value,
                                onClick: onManagePayment
                            }, [
                                _createElementVNode("div", _hoisted_6, [
                                    (isCtaLoading.value)
                                        ? (_openBlock(), _createBlock(SvgIcon, {
                                            key: 0,
                                            name: "ellipsis",
                                            class: "w-full h-8 text-white"
                                        }))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('manage_payment')), 1))
                                ])
                            ], 10, _hoisted_5))
                            : _createCommentVNode("", true)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
